import {} from 'react-hook-form';
import { FormField } from '../FormField/FormField';
import type { FormFieldToggleBaseProps } from '../FormField/FormField.types';
import { LabeledControl } from '../LabeledControl/LabeledControl';
import { Radio } from '../Radio/Radio';
import type { RadioProps } from '../Radio/Radio.types';

export type RadioFieldProps = RadioProps & FormFieldToggleBaseProps;

export const RadioField = (props: RadioFieldProps) => {
  const {
    className,
    description,
    disabled,
    helperText,
    label,
    labelTooltip,
    error,
    hasError,
    innerRef,
    ...restProps
  } = props;
  return (
    <FormField
      {...restProps}
      className={className}
      label={label}
      labelTooltip={labelTooltip}
      disabled={disabled}
      error={error}
    >
      <LabeledControl
        {...restProps}
        control={
          <Radio
            {...restProps}
            hasError={hasError || error !== undefined}
            disabled={disabled}
            innerRef={innerRef}
          />
        }
        disabled={disabled}
        description={description}
        helperText={helperText}
      />
    </FormField>
  );
};
